module.exports = __webpack_public_path__ + "02_glasses_red.dda540cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer4/02_glasses_red.png
// module id = Sbqg
// module chunks = 0